import { readRasterUploadMetadata } from "./read-raster-upload-metadata";

export const buildS3UploadResponseString = async ({
  file,
  format,
  publicId,
}: {
  file: File;
  format: string;
  publicId: string;
}): Promise<string> => {
  const metadata = await readRasterUploadMetadata(file);
  const params = new URLSearchParams({
    format,
    public_id: publicId,
    width: String(metadata.width),
    height: String(metadata.height),
    bytes: String(metadata.bytes),
  });

  const { imageMetadata } = metadata;

  if (imageMetadata) {
    params.set("image_metadata[XResolution]", imageMetadata.XResolution);
    params.set("image_metadata[YResolution]", imageMetadata.YResolution);

    if (imageMetadata.ResolutionUnit) {
      params.set(
        "image_metadata[ResolutionUnit]",
        imageMetadata.ResolutionUnit
      );
    }
  }

  return params.toString();
};
